import { motion } from "framer-motion";
import { Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { useShortlist } from "@/context/ShortlistContext";

export const SelectButton = ({ item, variant = "icon" }) => {
  const { has, toggle } = useShortlist();
  const on = has(item.id);
  const click = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(item.id);
    toast(on ? `Removed ${item.name} from your selection` : `Added ${item.name} to your selection`);
  };

  if (variant === "full")
    return (
      <button onClick={click} data-testid="item-select-btn"
        className={`h-12 inline-flex items-center justify-center gap-2 rounded-full px-6 text-sm border transition-colors duration-300 ${on ? "bg-[#F5F3EF] text-[#0D0D11] border-[#F5F3EF]" : "border-[#D4AF37]/50 text-[#E5C158] hover:bg-[#D4AF37]/10"}`}>
        {on ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
        {on ? "In your selection" : "Add to selection"}
      </button>
    );

  return (
    <motion.button whileTap={{ scale: 0.85 }} onClick={click} data-testid={`select-toggle-${item.id}`}
      aria-label={on ? "Remove from selection" : "Add to selection"}
      className={`w-10 h-10 grid place-items-center rounded-full backdrop-blur-md border transition-colors duration-300 ${on ? "bg-[#D4AF37] border-[#D4AF37] text-[#0D0D11]" : "bg-[#0D0D11]/60 border-[#D4AF37]/40 text-[#E5C158] hover:bg-[#D4AF37]/20"}`}>
      {on ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
    </motion.button>
  );
};
